import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { useDispatch } from 'react-redux';
import { TagSelector } from '../../../components/Taxonomy/TagSelector';
import { searchMediaTags } from '../../../modules/Media/redux/media.actions';
import { FullMediaTags } from '../../../modules/Media/redux/media.selectors';
import { HorizontalStack, SmartContainer, Stack, StyledGrid, StyledGridItem, Surface } from '../../../styles/Containers';
import { HelperToDo } from '../../../styles/Helpers';
import { StyledButton } from '../../../styles/matieralui/Button';
import { StyledModal } from '../../../styles/matieralui/Modal';
import { StyledB, StyledH6, StyledP } from '../../../styles/StyledHTML';
import { searchAlbum, replaceAlbumTags, createAlbum } from '../Album/redux/album.actions';
import { FullAlbums } from '../Album/redux/album.selectors';
import { replaceLocationTags, searchLocations } from '../Location/redux/locations.actions';
import { FullLocations } from '../Location/redux/locations.selectors';

import { TERM_ALBUM, TERM_ALBUM_PLURAL, TERM_LIBRARY, useAnimatedUploadedScreen } from '../../services/CaptureCollabService';
import { animated } from 'react-spring';
import { StyledCircularProgress } from '../../../styles/matieralui/Progress';
import { Divider } from '@mui/material';
import { MediaErrorPreview, MediaUpload } from '../../../modules/Media/MediaUpload';

import { replaceLibraryTags } from '../Library/redux/library.actions';
import { replaceGenericTags, searchGenericTags } from '../GenericTags/redux/generictags.actions';
import { FullGenericTags } from '../GenericTags/redux/generictags.selectors';

import { FullPeople } from '../People/redux/people.selectors';
import { replacePeopleTags, searchPeople } from '../People/redux/people.actions';
import { validFileTypes } from '../../../config';
import { IconUpload, IconView } from '../../Icons';
import { TagSelectorWithAutoComplete } from '../../../components/Taxonomy/TagSelectorWithAutoComplete';
import { DirectMediaUpload } from '../../../modules/Media/DirectMediaUpload';

export const DashedSurface = styled(Surface)`

    padding: 2em;
    border: 2px dashed rgba(0,0,0,0.25);

`


export const Screen = ({ children, ...rest }) => {
    const { animatedProps } = useAnimatedUploadedScreen();
    return (

        <SmartContainer>
            <animated.div style={animatedProps}>
                {children}
            </animated.div>
        </SmartContainer>
    )
}


export const Uploader = ({ libraryId, library, albumId = null, album = null, label = "Let's get started", onComplete }) => {
    const [ready, setReady] = useState(false);
    const [albums, setAlbums] = useState([]);
    const [locations, setLocations] = useState([]);
    const [people, setPeople] = useState([]);
    const [tags, setTags] = useState([]);
    const [screen, setScreen] = useState('albums') // albums, location, tags, save
    const [loading, setLoading] = useState(false);
    const [uploadStats, setUploadStats] = useState(null);
    const dispatch = useDispatch();

    const { animatedProps } = useAnimatedUploadedScreen();

    // Selectors
    const storeAlbums = FullAlbums();
    const albumsPrefix = 'libraryAlbums';
    const storeLocations = FullLocations();
    const storePeople = FullPeople();
    const storeTags = FullGenericTags();

    // Load Albums
    const loadAlbumsForLibrary = () => {
        const args = {}
        // args.Library = libraryId;
        args.LibraryId = `["${libraryId}"]`
        args['prefix'] = albumsPrefix;
        dispatch(searchAlbum(0, null, null, 'all', args))
    }

    // Load Locations
    const loadLocations = () => {
        const args = {}
        dispatch(searchLocations(0, null, null, 'all', args))
    }

    // Load Tags
    const loadGenericTags = () => {
        dispatch(searchGenericTags(0, null, null, 'all'))
    }

    // Load Tags
    const loadPeople = () => {
        dispatch(searchPeople(0, null, null, 'all'))
    }



    const removeDuplicates = (arr) => {
        const storage = []
        const filtered = arr.filter(item => {
            if (!storage.includes(String(item.name).toLowerCase())) {
                storage.push(String(item.name).toLowerCase())
                return item;
            }
            return false;

        })
        return filtered;
    }


    const createEnvironment = async (args) => {
        setLoading(true);
        setScreen('creating');

        // Valid Album
        // TODO: This currently only works for Single Albums not arrays.
        const album = args.albums[0];

        if (album?.id) {
            // Do Nothing. We have the info that we need.
            setupUploadArea(args);
        } else {
            dispatch(createAlbum({ name: album.name, LibraryId: libraryId }))

        }


    }

    const setupUploadArea = (args) => {

        setScreen('upload');
    }

    useEffect(() => {
        if (storeAlbums?.createSuccess) {
            if (!ready) return; // This stops the setup if we land here after creating an album somewhere else.
            // Replace Album Args and Run.
            const newAlbums = albums.map(item => {
                if (item.name === storeAlbums.create.name) return storeAlbums.create;
                return item;
            })
            const args = {
                libraryId,
                albums: newAlbums,
                locations,
                tags
            }
            setAlbums(newAlbums);
            setupUploadArea(args);

        }
    }, [storeAlbums])

    useEffect(() => {
        setReady(true)
    }, [])

    useEffect(() => {
        if (!libraryId) return;

        // Get Albums Assoicated with the Library
        loadAlbumsForLibrary();

        // Get Locations Associated with the libary
        loadLocations();

        // Get Generic Tags
        loadGenericTags();

        // Get People
        loadPeople();

    }, [libraryId])

    useEffect(() => {
        if (!album) {
            setAlbums([])
        } else {
            setAlbums([album]);
            setScreen('location');
        }

    }, [album])



    const handleAlbumChange = (data) => setAlbums(data);
    const handleLocationChange = (data) => setLocations(data);
    const handleMediaTagChange = (data) => setTags(data);
    const handlePeopleChange = (data) => setPeople(data);

    const prev = () => {
        if (screen === 'save') setScreen('tags');
        else if (screen === 'tags') setScreen('people');
        // else if (screen === 'tags') setScreen('location');
        else if (screen === 'people') setScreen('location');
        else if (screen === 'location') setScreen('albums');
    }
    const next = () => {
        if (screen === 'save') return;
        else if (screen === 'tags') setScreen('save');
        else if (screen === 'people') setScreen('tags');
        else if (screen === 'location') setScreen('people');
        // else if (screen === 'location') setScreen('tags');
        else if (screen === 'albums') setScreen('location');
    }
    const save = () => {
        const args = {
            libraryId,
            albums,
            locations,
            tags,
            people
        }
        createEnvironment(args);
    }


    // Tag The Asset
    const tagAssetByLibraries = (terms, assetId) => dispatch(replaceLibraryTags(terms, 'Asset', assetId))
    const tagAssetByAlbums = (terms, assetId, libraryId) => dispatch(replaceAlbumTags(terms, 'Asset', assetId, { LibraryId: libraryId }))
    const tagAssetByLocations = (terms, assetId) => dispatch(replaceLocationTags(terms, 'Asset', assetId))
    const tagAssetByGenericTags = (terms, assetId) => dispatch(replaceGenericTags(terms, 'Asset', assetId))
    const tagAssetByPeople = (terms, assetId) => dispatch(replacePeopleTags(terms, 'Asset', assetId));


    const onUploadCallback = (asset) => {

        if (!asset) return;

        // Apply The Tags to The Newly Created Asset.
        tagAssetByLibraries([library], asset.id)

        // Albums
        const theAlbums = removeDuplicates(albums);
        tagAssetByAlbums(theAlbums, asset.id, libraryId);

        // Locations
        const theLocations = removeDuplicates(locations);
        tagAssetByLocations(theLocations, asset.id);

        // People
        const thePeople = removeDuplicates(people);
        tagAssetByPeople(thePeople, asset.id);

        // Generic Tags
        let combinedTagswithExix = [...tags];
        if (asset?.meta?.exif?.tags) {
            const formattedExif = asset?.meta?.exif?.tags.map(i => { return { name: i } })
            combinedTagswithExix = [...tags, ...formattedExif];
        }

        const theTags = removeDuplicates(combinedTagswithExix);
        tagAssetByGenericTags(theTags, asset.id);

    }



    const onCompleteUpload = () => {
        if (onComplete) {
            const args = {
                libraryId,
                albums,
                locations,
                tags,
                people
            }
            onComplete(args);
        }
    }

    const handleCompletedUpload = (args) => {
        setScreen('completed');
        setUploadStats(args);
    }


    return (
        <DashedSurface variant="inverse">
            <Stack>


                <SmartContainer >
                    {albums.length > 0 && (
                        <HorizontalStack flex>
                            <StyledB>{TERM_ALBUM_PLURAL}</StyledB>
                            {albums?.map(item => (<StyledP>{item.name}</StyledP>))}
                        </HorizontalStack>
                    )}
                    {locations.length > 0 && (
                        <HorizontalStack flex>
                            <StyledB>Locations</StyledB>
                            {locations?.map(item => (<StyledP>{item.name}</StyledP>))}
                        </HorizontalStack>
                    )}
                    {people.length > 0 && (
                        <HorizontalStack flex>
                            <StyledB>People</StyledB>
                            {people?.map(item => (<StyledP>{item.name}</StyledP>))}
                        </HorizontalStack>
                    )}
                    {tags.length > 0 && (
                        <HorizontalStack flex>
                            <StyledB>Tags</StyledB>
                            {tags?.map(item => (<StyledP>{item.name}</StyledP>))}
                        </HorizontalStack>
                    )}
                </SmartContainer>

                {(albums.length > 0 || locations.length > 0 || tags.length > 0) && (
                    <SmartContainer>
                        <p>&nbsp;</p>
                        <Divider />
                        <p>&nbsp;</p>
                    </SmartContainer>)
                }





                <SmartContainer flex align="center" justify="center">
                    <Stack maxWidth="450px" textAlign="center">

                        {screen === 'albums' && (
                            <Screen>
                                <StyledH6>Select or Create a {TERM_ALBUM}</StyledH6>
                                <br />
                                <StyledP>{TERM_ALBUM_PLURAL} are how photos stay together within a {TERM_LIBRARY}. Creating an {TERM_ALBUM} or adding to it will make it easier to locate your photos.</StyledP>
                                <br />
                                <TagSelector
                                    noLabels={true}
                                    inputLabel={`${TERM_ALBUM} name`}
                                    existingOptions={albums}
                                    options={storeAlbums[albumsPrefix]?.rows}
                                    onChange={handleAlbumChange}
                                    limit={1}
                                    helperText="Ex. Ruth’s Wedding or Product Photos"
                                />
                            </Screen>
                        )}

                        {screen === 'location' && (
                            <Screen>
                                <StyledH6>Select or Add Location</StyledH6>
                                <br />
                                <StyledP>Location can include the city, state, or venue where your {TERM_ALBUM} of photos was captured.</StyledP>
                                <br />
                                {/* <TagSelector
                                    noLabels={true}
                                    inputLabel="Location"
                                    existingOptions={locations}
                                    options={storeLocations?.items?.rows}
                                    onChange={handleLocationChange}
                                    helperText="Ex. Nashville, Tennessee or Walt Disney World"
                                /> */}
                                <TagSelectorWithAutoComplete
                                    noLabels={true}
                                    inputLabel="Location"
                                    existingOptions={locations}
                                    selector={FullLocations}
                                    action={searchLocations}
                                    onChange={handleLocationChange}
                                    staticOptions={storeLocations?.fulldataset?.rows}
                                    helperText="Ex. Nashville, Tennessee or Walt Disney World"
                                />
                            </Screen>
                        )}

                        {screen === 'people' && (
                            <Screen>
                                <StyledH6>Select or Add a Person</StyledH6>
                                <br />
                                <StyledP>The people you add here will be tagged in EVERY photo you upload.</StyledP>
                                <br />
                                {/* <TagSelector
                                    noLabels={true}
                                    inputLabel="Person"
                                    existingOptions={people}
                                    options={storePeople?.items?.rows}
                                    onChange={handlePeopleChange}
                                    helperText="Ex. John Doe, Walt Disney"
                                /> */}
                                <TagSelectorWithAutoComplete
                                    noLabels={true}
                                    inputLabel="Person"
                                    existingOptions={people}
                                    selector={FullPeople}
                                    action={searchPeople}
                                    onChange={handlePeopleChange}
                                    staticOptions={storePeople?.fulldataset?.rows}
                                    helperText="Ex. John Doe, Walt Disney"
                                />
                            </Screen>
                        )}

                        {screen === 'tags' && (
                            <Screen>
                                <StyledH6>Select or Add Tags </StyledH6>
                                <br />
                                <StyledP>Tags make it possible to search and quickly find your photos later. Tags can be as general or as specific as you’d like.</StyledP>
                                <br />

                                {/* <TagSelector
                                    noLabels={true}
                                    inputLabel="Tags"
                                    existingOptions={tags}
                                    options={storeTags?.items?.rows}
                                    onChange={handleMediaTagChange}
                                    helperText="Ex. Night or Nature or Architecture or People"
                                /> */}
                                <TagSelectorWithAutoComplete
                                    noLabels={true}
                                    inputLabel="Tags"
                                    existingOptions={tags}
                                    selector={FullGenericTags}
                                    action={searchGenericTags}
                                    onChange={handleMediaTagChange}
                                    staticOptions={storeTags?.fulldataset?.rows}
                                    helperText="Ex. Night or Nature or Architecture or People"
                                />
                            </Screen>
                        )}

                        {screen === 'save' && (
                            <Screen>
                                <StyledH6>Save &amp; Start Uploading</StyledH6>
                                <br />
                                <StyledP>Save your Album Name, Location, and Tags to start uploading photos.</StyledP>
                            </Screen>
                        )}

                        {screen === 'creating' && (
                            <Screen>
                                <Stack flex direction="column" align="center" justify="center">
                                    <StyledCircularProgress />
                                    <StyledP>Creating {TERM_ALBUM_PLURAL} and tags</StyledP>
                                </Stack>

                            </Screen>
                        )}

                        {screen === 'completed' && (
                            <Screen>
                                <Stack textAlign="center">

                                    <SmartContainer><StyledH6 textAlign="center">🎉<br />Upload Complete!</StyledH6></SmartContainer>
                                    <SmartContainer><StyledP light>That was easy enough!</StyledP></SmartContainer>
                                    <br />
                                    {uploadStats?.uploadErrorFiles?.length > 0 && (
                                        <SmartContainer>
                                            <StyledP light>Some files didn't upload though. See below. If this persist please reach out to support.</StyledP>
                                        </SmartContainer>
                                    )}
                                    <HorizontalStack flex justify="center">
                                        <StyledButton variant='contained' onClick={() => setScreen('upload')} ><IconUpload />Upload More</StyledButton>
                                        <StyledButton variant='contained' color="blue" onClick={onCompleteUpload}><IconView /> View Assets</StyledButton>
                                    </HorizontalStack>
                                </Stack>
                                <br />
                                <Stack textAlign="left">
                                    {uploadStats?.uploadErrorFiles?.map(file => (
                                        <MediaErrorPreview key={file.path} file={file} />
                                    ))}
                                </Stack>
                            </Screen>
                        )}




                        {screen !== "creating" && screen !== "upload" && screen !== 'completed' && (
                            <Stack>
                                <HorizontalStack flex justify="center">
                                    {screen != 'albums' && (<StyledButton variant="outlined" onClick={prev}>Previous</StyledButton>)}
                                    {screen != 'save' && albums?.length > 0 && (<StyledButton variant='outlined' onClick={next}>Next</StyledButton>)}
                                    {screen === 'save' && (<StyledButton variant="contained" color="pop" onClick={save}>Save & Start Uploading</StyledButton>)}
                                </HorizontalStack>

                            </Stack>
                        )}
                    </Stack>
                </SmartContainer>

                {screen === 'upload' && (
                    <Screen>
                        <Stack flex direction="column" align="center" justify="center">
                            {/* <MediaUpload maxSize={70000000} accept={validFileTypes} onSuccessfulUpload={onUploadCallback} isAsset={true} onCompleteUpload={handleCompletedUpload} /> */}
                            <DirectMediaUpload accept={validFileTypes} onSuccessfulUpload={onUploadCallback} isAsset={true} onCompleteUpload={handleCompletedUpload} />
                        </Stack>

                    </Screen>
                )}



            </Stack>
        </DashedSurface >
    )
}